import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab, Paper, withStyles, Typography, Box } from '@material-ui/core';
import { parseURL, BackButton, hasPermission } from '../../sc-utilities';
import ErasureHistory from './ErasureHistory';
import ProductPaletteHistoryList from './ProductPaletteHistory';
import { updateURL } from "../../sc-utilities";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        margin: theme.spacing(),
        [theme.breakpoints.down('md')]: {
            width: `97.8%`
        },
        [theme.breakpoints.down('sm')]: {
            width: `97.8%`
        }
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 3 * 3 }}>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}


const ProductHistories = props => {
    const { classes, theme, translations, permissions } = props;
    let searchParams = parseURL(window.location.search);
    const [tabValue, setTabValue] = useState(getTabValue());

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };


    return (<>
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Tabs
                value={tabValue}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                {hasPermission(permissions, 'product_view_history') ? <Tab label={translations['erasure_history'] || "Erasure history"} /> : null}
                {hasPermission(permissions, 'product_palette_history_list') ? <Tab label={translations['palette_history'] || "Palette history"} /> : null}
            </Tabs>
        </Paper>

        {hasPermission(permissions, 'product_view_history') ? <TabPanel index={0} value={tabValue}>  <TabContainer dir={theme.direction}> <ErasureHistory productID={searchParams.productID} /> </TabContainer> </TabPanel> : null}
        {hasPermission(permissions, 'product_palette_history_list') ? <TabPanel index={1} value={tabValue}>  <TabContainer dir={theme.direction}><ProductPaletteHistoryList productID={searchParams.productID} /> </TabContainer> </TabPanel> : null}
    </>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        histories: state.product.histories,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(ProductHistories));